export const ADMIN_API_CONFIG = {
  API_URL: process.env.NEXT_PUBLIC_API_URL,
  BASE_URL: process.env.BASE_URL,
  IMAGES_DOMAIN: process.env.URL_IMAGES_PRODUCTION,
}
